import React, { useState } from 'react';
import classNames from 'classnames';
import SubHeader from './SubHeader.jsx';
import RightArrowIcon from './icons/RightArrowIcon.jsx';
import styles from './ToggleBlock.module.css';

const ToggleBlock = ({ children, title, showOnStart, titleComponent }) => {
  const [isHidden, setIsHidden] = useState(!showOnStart);

  const className = classNames('toggle-section', styles.toggleSection, {
    'toggle-hidden': isHidden,
    [styles.toggleHidden]: isHidden,
  });
  return (
    <section className={className}>
      <SubHeader flex small className={className}>
        <h2 style={{ minWidth: '350px' }}>
          <button
            className="btn-clear bg-transparent flex"
            onClick={() => setIsHidden(!isHidden)}
            type="button"
          >
            <RightArrowIcon className="collapse-caret" />
            <div className="m-l-16">{title || titleComponent}</div>
          </button>
        </h2>
      </SubHeader>
      {!isHidden && children}
    </section>
  );
};

export default ToggleBlock;
